<template>
  <div class="main-app">
    <BannerCom :src="src" />
    <div class="container">
      <div class="content">
        <el-row>
          <el-col :span="6" :xs="24">
            <div class="product-menu">
              <Menu
                :title="menuData.title"
                :lists="menuData.data"
                @on-click="onClickMenu"
              />
            </div>
          </el-col>
          <el-col :span="18" :xs="24">
            <div class="product-body">
              <div
                class="content-wrap"
                v-html="
                  productDetailData !== undefined
                    ? productDetailData.content
                    : ''
                "
              ></div>
              <!-- <section>
                <div class="info-head">
                  <div class="product-img">
                    <img
                      :src="
                        productDetailData !== undefined
                          ? productDetailData.image
                          : ''
                      "
                      alt=""
                    />
                  </div>
                </div>
                <div class="product-info">
                  <div class="info-title">
                    {{
                      productDetailData !== undefined
                        ? productDetailData.name
                        : ""
                    }}
                    <p>
                      {{
                        productDetailData !== undefined
                          ? productDetailData.push_text
                          : ""
                      }}
                    </p>
                  </div>
                  <div class="info-tips">
                    可完全满足国产和进口多个摩托车电喷系统的检测和诊断。本产品采用32位处理器和3.2寸彩色显示屏，支持大容量存储器。本产品操作简
                  </div>
                </div>
              </section>
              <section>
                <div class="title">产品使用视频</div>
                <div
                  class="info-wrap"
                  v-html="
                    productDetailData !== undefined
                      ? productDetailData.content
                      : ''
                  "
                ></div>
              </section> -->
              <!-- <section>
                <div class="title">使用手册</div>
                <div class="info-wrap">
                  <div class="icon-img">
                    <img src="~@a/img/maps.png" alt="" />
                  </div>
                </div>
              </section> -->
              <!-- <section>
                <div class="title">维修指引导航</div>
                <div class="info-wrap">
                  <div class="icon-img">
                    <img src="~@a/img/maps.png" alt="" />
                  </div>
                </div>
              </section> -->
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import { mapMutations } from "vuex";
import LStore from "store";
import { timeFormatDate, timeFormatYear, timeFormatMD } from "@/utils";
import BannerCom from "@c/BannerCom";
import Menu from "@c/Menu";

export default {
  filters: {
    timeFormatDate,
    timeFormatYear,
    timeFormatMD
  },
  data() {
    return {
      menuData: {
        title: this.$t("classify"),
        data: []
      },
      src: require("@a/img/banner-product.png"),
      productDetailData: undefined
    };
  },
  components: {
    BannerCom,
    Menu
  },
  created() {
    this.productCat();
    this.productDetail({ id: this.$route.query.id });
  },
  methods: {
    ...mapMutations(["PRODUCT_DATA"]),
    productCat(params) {
      API.productCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.PRODUCT_DATA(res.data);
          LStore.set("productData", res.data);
          this.$set(this.menuData, "data", res.data);
          if (res.data[0].children !== undefined) {
          
            // this.productDetail({ id: res.data[0].children[0].pid });
          } else {
            // this.productDetail({ id: res.data[0].pid });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    productDetail(params) {
      API.productDetail(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "productDetailData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    catdetail(params) {
      API.catdetail(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "productDetailData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onClickMenu(v) {
      if (v.data.children === undefined) {
        this.$router.push({
          path: "product",
          query: {
            cat: v.data.id
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.product-menu {
  margin-top: 40px;
  padding-right: 80px;
}
.product-body {
  margin: 40px 0;

  .info-head {
    display: flex;
    align-items: center;
    justify-content: center;

    .product-img {
      width: 200px;
    }
  }

  .product-info {
    font-size: 14px;
    color: var(--color-black);
    line-height: 30px;

    .info-title {
      font-size: 25px;
      color: var(--color-black);
      font-weight: bold;
      margin: 20px 0;

      p {
        font-size: 18px;
        color: var(--color-light-grey);
        font-weight: normal;
        margin-top: 5px;
      }
    }
  }

  .title {
    display: flex;
    height: 100px;
    align-items: center;
    font-size: 18px;
    color: var(--color-light-black);
    font-weight: bold;

    &::before {
      display: inline-block;
      content: "";
      width: 11px;
      height: 11px;
      margin-right: 15px;
      background: var(--color-green);
    }
  }

  .info-wrap {
    padding: 0 30px;

    .icon-img {
      &:not(:last-child) {
        margin-bottom: 20px;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .product-menu {
    padding: 0;
  }
}
</style>
